import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { DialogHeaderComponent, DialogFooterComponent, ButtonComponent } from '@akostm/orbit-ui';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ConfirmDialogData } from '../../../../interfaces';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'shared-confirm-dialog',
  standalone: true,
  imports: [DialogHeaderComponent, DialogFooterComponent, ButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent implements OnInit {
  data: ConfirmDialogData = inject(DIALOG_DATA);
  readonly #translateService = inject(TranslateService);
  readonly #dialogRef = inject(DialogRef);

  ngOnInit(): void {
    this.data.title =
      this.data.title || this.#translateService.instant('SHARED.DIALOGS.CONFIRM_DIALOG.TITLE');
    this.data.cancelLabel =
      this.data.cancelLabel ||
      this.#translateService.instant('SHARED.DIALOGS.CONFIRM_DIALOG.CANCEL_LABEL');
    this.data.confirmLabel =
      this.data.confirmLabel ||
      this.#translateService.instant('SHARED.DIALOGS.CONFIRM_DIALOG.CONFIRM_LABEL');
  }

  closeDialog(decision: boolean) {
    this.#dialogRef.close(decision);
  }
}
